import AppTable from '@/components/AppTable';
import { Button, Empty } from 'antd';
import React from 'react';
import PieceCreate from './PieceCreate';
import PieceUpdate from './PieceUpdate';
import { getActiveBadge } from '@/utils/getActiveBadge';
import { formatNumber } from '@/utils/formatters';

const columns = [
  {
    title: 'No.',
    dataIndex: 'id',
    key: 'id',
    render: (_, __, index) => <span>{index + 1}</span>,
  },
  {
    title: 'Piece Name',
    dataIndex: 'name',
    key: 'piece_name',
  },
  {
    title: 'Ordinal',
    dataIndex: 'ordinal_number',
    key: 'ordinal_number',
  },
  {
    title: 'Drop Rate',
    dataIndex: 'percent',
    key: 'drop_rate',
    render: (data) => <span>{data}%</span>,
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity_piece',
    key: 'quantity',
    render: (data) => (data ? formatNumber(data) : '0'),
  },
  {
    title: 'Limited',
    dataIndex: 'is_limited',
    key: 'is_limited',
    render: (data) =>
      getActiveBadge(+data, {
        activeText: 'Yes',
        inactiveText: 'No',
      }),
  },
  {
    title: 'Active',
    dataIndex: 'is_active',
    key: 'is_active',
    render: (data) =>
      getActiveBadge(+data, {
        activeText: 'Yes',
        inactiveText: 'No',
      }),
  },
  {
    title: 'Image',
    // dataIndex: 'image_path',
    key: 'image',
    render: (imagePath, record, index) => {
      let image;
      if (record?.image_file) {
        image = URL.createObjectURL(record?.image_file);
      } else {
        image = `${process.env.REACT_APP_API_BASEURL}${record?.image_path}`;
      }
      return (
        <div className="w-full flex justify-center">
          <img src={image} alt="Piece" className="w-[50px] h-[50px] object-cover" />
        </div>
      );
    },
  },
];

function PieceTable({
  pieceList,
  setPieceList,
  onOpenCreate,
  dataSource,
  rowActionEdit,
  rowActionDelete,
  openUpdate,
  openCreate,
  setOpenCreate,
  setOpenUpdate,
  isNewPiece,
  ...props
}) {
  return (
    <>
      <AppTable
        tableTitle={<h2 className="font-semibold">Piece List</h2>}
        columns={columns}
        dataSource={dataSource}
        onRefresh={null}
        hasPagination={false}
        hasRowAction
        {...props}
        locale={{
          emptyText: (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No piece created">
              <Button type="primary" onClick={onOpenCreate}>
                Create Piece
              </Button>
            </Empty>
          ),
        }}
        removeItemsLabel="Delete"
      />

      <PieceCreate
        openPieceModal={openCreate}
        setOpenPieceModal={setOpenCreate}
        setPieceList={setPieceList}
      />

      <PieceUpdate
        openPieceModal={openUpdate}
        setOpenPieceModal={setOpenUpdate}
        isNewPiece={isNewPiece}
        setPieceList={setPieceList}
      />
    </>
  );
}

export default PieceTable;
